// Theme definitions with a unified color system:
// - mainBackground: Main content area background
// - secondaryBackground: Sidebar/card background
// - textColor: Primary text color
// - secondaryTextColor: Secondary text (lighter)
// - primaryActionColor: Primary accent/action (buttons, links)
// - secondaryActionColor: Secondary accent (complementary)
// - buttonTextColor: Text color for action buttons
// - shadowColor: Border/shadow color for dividers

export const themes = {
  cobweb: {
    name: 'Cobweb',
    description: 'Cool grey canvas with teal actions',
    mainBackground: '#F6F8FA',
    secondaryBackground: '#ECEEF1',
    shadowColor: '#D8DCE3',
    textColor: '#1A1F36',
    secondaryTextColor: '#697386',
    primaryActionColor: '#0D9488',
    secondaryActionColor: '#2563EB',
    buttonTextColor: '#FFFFFF',
  },
  cream: {
    name: 'Cream',
    description: 'Cozy and comfortable for long sessions',
    mainBackground: '#F7F2EA',
    secondaryBackground: '#EFE9DE',
    shadowColor: '#DED6CA',
    textColor: '#26211A',
    secondaryTextColor: '#6B6459',
    primaryActionColor: '#C1591A',
    secondaryActionColor: '#B3261E',
    buttonTextColor: '#FFFFFF',
  },
  midnight: {
    name: 'Midnight',
    description: 'Easy on the eyes for late nights',
    mainBackground: '#1F2937',
    secondaryBackground: '#111827',
    shadowColor: '#374151',
    textColor: '#F9FAFB',
    secondaryTextColor: '#9CA3AF',
    primaryActionColor: '#22D3EE',
    secondaryActionColor: '#34D399',
    buttonTextColor: '#000000',
  },
};

const LEGACY_THEME_KEYS = {
  dark: 'midnight',
  light: 'cobweb',
  daybreak: 'cobweb',
};

// Get theme from localStorage or default to cobweb
export const getStoredTheme = () => {
  try {
    const stored = localStorage.getItem('app-theme');
    if (stored && themes[stored]) {
      return stored;
    }
    if (stored && LEGACY_THEME_KEYS[stored]) {
      return LEGACY_THEME_KEYS[stored];
    }
    return 'cobweb';
  } catch {
    return 'cobweb';
  }
};

// Save theme to localStorage
export const saveTheme = (themeName) => {
  try {
    localStorage.setItem('app-theme', themeName);
  } catch (error) {
    console.error('Failed to save theme:', error);
  }
};

// Apply theme to document using CSS variables
export const applyTheme = (themeName) => {
  const theme = themes[themeName];
  if (!theme) return;

  const root = document.documentElement;
  root.style.setProperty('--theme-main-bg', theme.mainBackground);
  root.style.setProperty('--theme-secondary-bg', theme.secondaryBackground);
  root.style.setProperty('--theme-shadow', theme.shadowColor);
  root.style.setProperty('--theme-text', theme.textColor);
  root.style.setProperty('--theme-secondary-text', theme.secondaryTextColor);
  root.style.setProperty('--theme-primary', theme.primaryActionColor);
  root.style.setProperty('--theme-secondary', theme.secondaryActionColor);
  root.style.setProperty('--theme-button-text', theme.buttonTextColor);
  root.setAttribute('data-theme', themeName);
};
